import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react'
import { createContext, useContext, useMemo, useState } from 'react'

interface ExportSocialContextValues {
  filledAccountsMap: Record<string, boolean>
  setFilledAccountsMap: Dispatch<SetStateAction<Record<string, boolean>>>
}

const ExportSocialContext = createContext<ExportSocialContextValues | null>(
  null,
)

export const ExportSocialProvider: FC<PropsWithChildren> = ({ children }) => {
  const [filledAccountsMap, setFilledAccountsMap] = useState<
    Record<string, boolean>
  >({})

  const value = useMemo(
    () => ({
      filledAccountsMap,
      setFilledAccountsMap,
    }),
    [filledAccountsMap, setFilledAccountsMap],
  )

  return (
    <ExportSocialContext.Provider value={value}>
      {children}
    </ExportSocialContext.Provider>
  )
}

export const useExportSocial = () => {
  const context = useContext(ExportSocialContext)

  if (context === null) {
    throw new Error(
      'useExportSocial must be used within a ExportSocialContextProvider',
    )
  }

  return context
}
